import AuthenticationService from '@services/Authentication';
import assign from 'object-assign';
import Cookies from 'js-cookie';
import {COOKIES} from '@util/StorageUtils';
import {jqueryValidate} from '@modules/lazy-imports';

const Page = assign( {
    async init () {
        await jqueryValidate();

        this.validator = $( '#loginForm' ).validate( {
            submitHandler: () => {
                return false;
            }
        } );

        this.initTokenDisplay();

        const buttons = [].slice.call( document.querySelectorAll( '#body-content .button' ) );

        buttons.forEach( btn => {
            btn.addEventListener( 'click', ( e ) => {
                const target = e.target;
                const action = target.getAttribute( 'data-action' );

                switch ( action ) {
                    case 'setGuestToken':
                        this.createGuestToken();
                        break;

                    case 'authenticateUser':
                        if ( !this.validator.form() ) {
                            return;
                        }
                        const username = document.getElementById( 'username' );
                        const password = document.getElementById( 'password' );
                        const fakeRole = document.getElementById( 'role' );
                        this.authenticateUser( username.value, password.value, fakeRole.value );
                        break;

                    case 'clearToken':
                        this.clearToken();
                        this.clearUserInfo();
                        this.displayToken( 'Token not set' );
                        this.displayUserInfo();
                        break;

                    default:
                        console.warn( `Unknown action "${action}"` );
                }

            }, false );
        } );
    },
    initTokenDisplay () {
        const authToken = Cookies.get( COOKIES.AUTH_TOKEN.name );
        if ( authToken ) {
            this.displayToken( authToken );
            this.displayUserInfo();
        }
        else {
            this.clearUserInfo();
        }
    },
    authenticateUser ( username, password, fakeRole ) {
        AuthenticationService
            .getUserAuthToken( username, password, fakeRole )
            .then( ( data ) => {
                if ( !data || !data.token ) {
                    throw Error( 'Login failed' );
                }

                const {token, customer} = data;
                this.setAuthToken( token );
                this.setUserInfo( customer, fakeRole );
                return token;
            } )
            .then( token => {
                this.displayToken( token );
                this.displayUserInfo();
                return this;
            } )
            .catch( err => console.error( err ) );
    },
    createGuestToken () {
        AuthenticationService
            .getGuestToken()
            .then( this.setAuthToken )
            .then( token => {
                this.clearUserInfo();
                this.displayToken( token );
                this.displayUserInfo();
                return this;
            } )
    },
    setAuthToken ( token ) {
        Cookies.set( COOKIES.AUTH_TOKEN.name, token );
        return token;
    },
    clearToken () {
        Cookies.remove( COOKIES.AUTH_TOKEN.name );
    },
    displayToken ( token ) {
        document.getElementById( 'upi-token' ).value = token;
        return token;
    },
    setUserInfo ( customer, fakeRole ) {
        customer.role = fakeRole;

        try {
            localStorage.setItem( '__devUser', JSON.stringify( customer ) )
        }
        catch ( err ) {
            alert( err.message );
        }
    },
    clearUserInfo () {
        localStorage.setItem( '__devUser', null );
        document.getElementById( 'user-info' ).innerHTML = '';
    },
    displayUserInfo () {
        try {
            const customer = JSON.parse( localStorage.getItem( '__devUser' ) );
            const userDiv = document.getElementById( 'user-info' );

            if ( !Cookies.get( COOKIES.AUTH_TOKEN.name ) ) {
                return userDiv.innerHTML = '';
            }

            if ( !customer ) {
                return userDiv.innerHTML = `
                    <div class="bg-moon-grey my-4 p-4">
                        <h2>No user info available</h2>
                    </div>
                `;
            }

            const {email, firstName, lastName, account, role} = customer;
            userDiv.innerHTML = `
            <div class="bg-moon-grey my-4 p-4">
                <table>
                    <tr>
                        <th class="text-left w-32 pr-1">User Role</th>
                        <td>${role || 'Unknown'}</td>
                    </tr>
                    <tr>
                        <th class="text-left w-32 pr-1">Full Name</th>
                        <td>${firstName} ${lastName}</td>
                    </tr>
                    <tr>
                        <th class="text-left w-32 pr-1">Email</th>
                        <td>${email}</td>
                    </tr>
                    <tr>
                        <th class="text-left w-32 pr-1">Account Number</th>
                        <td>${account.accountNumber}</td>
                    </tr>
                </table>
            </div>
            `;
        }
        catch ( err ) {
            console.error( err );
        }
    }

} );

document.addEventListener( 'DOMContentLoaded', function () { Page.init(); } );